import React from 'react';
import { motion } from 'framer-motion';
import { Check, Star, Target, Zap, PlayCircle } from 'lucide-react';
import { Button } from './ui/Button';
export function Pricing() {
  const baseFeatures = ['✅ TOMO 1: Planificación Docente Anual', '✅ TOMO 2: Energía Solar para el Aula', '✅ TOMO 3: Energía Eólica y Otras Renovables', '✅ TOMO 4: Actividades y Trabajos Prácticos', '✅ TOMO 5: Evaluaciones y Rúbricas', '✅ TOMO 6: Proyectos y Feria de Ciencias', '🎁 BONO 1: 100 Actividades Listas para Imprimir', '🎁 BONO 2: Banco de Evaluaciones Editables', '🎁 BONO 3: Presentaciones para Clase', '🎁 BONO 4: Recursos para Ferias de Ciencias', '✅ Acceso de por vida', '✅ Actualizaciones gratuitas'];
  const maestroFeatures = ['✅ TOMO 1: Planificación Docente Anual', '✅ TOMO 2: Energía Solar para el Aula', '✅ TOMO 3: Energía Eólica y Otras Renovables', '✅ TOMO 4: Actividades y Trabajos Prácticos', '✅ TOMO 5: Evaluaciones y Rúbricas', '✅ TOMO 6: Proyectos y Feria de Ciencias', '🎁 BONO 1: 100 Actividades Listas para Imprimir', '🎁 BONO 2: Banco de Evaluaciones Editables', '🎁 BONO 3: Presentaciones para Clase', '🎁 BONO 4: Recursos para Ferias de Ciencias', '⚡ UPSELL: Mega Biblioteca Docente Premium', '✅ Acceso de por vida', '✅ Actualizaciones gratuitas'];
  const comparisonRows = [{
    sit: 'Vincular energías con producción',
    sin: 'No tenés material de ganadería sustentable',
    con: 'Módulo completo de bioenergía y ganadería sustentable'
  }, {
    sit: 'Gestionar proyectos institucionales',
    sin: 'Improvisás la gestión del proyecto',
    con: 'Guía completa de gestión institucional paso a paso'
  }, {
    sit: 'Conectar con el sector productivo',
    sin: 'No sabés cómo articular con empresas',
    con: 'Estrategias y contactos para vinculación productiva real'
  }, {
    sit: 'Participar en concursos',
    sin: 'No sabés qué concursos existen ni cómo prepararse',
    con: 'Guía de concursos nacionales e internacionales con bases'
  }, {
    sit: 'Desarrollo profesional',
    sin: 'Enseñás siempre igual',
    con: 'Estrategias pedagógicas avanzadas para renovables'
  }, {
    sit: 'Recursos bibliográficos',
    sin: 'Buscás en Google cada vez',
    con: 'Biblioteca digital curada y actualizada'
  }];
  return <section id="pricing" className="py-24 bg-[#0c241a]" data-id="element-201">
      <div className="container mx-auto px-4" data-id="element-202">
        <div className="text-center mb-16" data-id="element-203">
          <h2 className="md:text-5xl font-extrabold text-white mb-4 text-[28px]" data-id="element-204">
            🛒 ELEGÍ TU MEGAPACK
          </h2>
          <p className="text-slate-300 text-[16px]" data-id="element-205">
            Dos opciones · Mismo acceso inmediato
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-5xl mx-auto mb-10" data-id="element-206">
          {/* Opción 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-[#06140d] rounded-3xl p-8 shadow-2xl border border-[#1a3d2c] flex flex-col h-full relative z-10" data-id="element-207">
            <div className="mb-6" data-id="element-208">
              <p className="text-slate-400 font-bold uppercase tracking-wider text-sm mb-2" data-id="element-209">
                OPCIÓN 1 — Oferta principal
              </p>
              <h3 className="font-bold text-white mb-2 flex items-center gap-2 text-[20px]" data-id="element-210">
                📗 MEGAPACK ENERGÍAS RENOVABLES
              </h3>
              <p className="text-slate-400 font-medium" data-id="element-211">6 Tomos + 4 Bonos</p>
            </div>

            <div className="mb-6 pb-6 border-b border-[#1a3d2c]" data-id="element-212"></div>

            <div className="mb-8" data-id="element-213">
              <div className="flex items-end gap-2" data-id="element-214">
                <span className="text-5xl font-black text-white" data-id="element-215">$19.990</span>
                <span className="text-xl font-bold text-slate-400 mb-1" data-id="element-216">
                  ARS
                </span>
              </div>
              <p className="text-slate-500 line-through mt-1" data-id="element-217">$45.000 ARS</p>
            </div>

            <ul className="space-y-3 mb-8 flex-grow" data-id="element-218">
              {baseFeatures.map((feature, i) => <li key={i} className="flex items-start gap-2" data-id="element-219">
                  <span className="text-slate-300 text-[15px]" data-id="element-220">{feature}</span>
                </li>)}
            </ul>

            <a href="https://emprendepackcentral.store/cart/47825283023042:1" target="_blank" rel="noopener noreferrer" className="block" data-id="element-221">
              <Button variant="outline" size="lg" fullWidth data-id="element-222">
                🔥 QUIERO MI MEGAPACK AHORA
              </Button>
            </a>
          </motion.div>

          {/* Opción 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-[#06140d] rounded-3xl p-8 shadow-2xl border-2 border-slate-300 flex flex-col h-full relative z-10 transform lg:-translate-y-4" data-id="element-223">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-slate-200 text-slate-950 font-black px-4 py-1 rounded-full text-sm uppercase tracking-wider flex items-center gap-1 shadow-lg" data-id="element-224">
              <Zap className="w-4 h-4 fill-slate-950" data-id="element-225" /> MÁS ELEGIDO
            </div>

            <div className="mb-6 mt-2" data-id="element-226">
              <h3 className="font-bold text-white mb-2 flex items-center gap-2 text-[20px]" data-id="element-227">
                📗 MEGAPACK + MEGA BIBLIOTECA PREMIUM
              </h3>
              <p className="text-slate-300 font-bold" data-id="element-228">
                Todo lo anterior + Contenido Avanzado Exclusivo
              </p>
            </div>

            <div className="mb-6 pb-6 border-b border-emerald-900/50" data-id="element-229"></div>

            <div className="mb-8" data-id="element-230">
              <div className="flex items-end gap-2" data-id="element-231">
                <span className="text-5xl font-black text-white" data-id="element-232">$27.990</span>
                <span className="text-xl font-bold text-slate-300 mb-1" data-id="element-233">
                  ARS
                </span>
              </div>
              <p className="text-slate-500 line-through mt-1" data-id="element-234">$75.000 ARS</p>
            </div>

            <ul className="space-y-4 mb-8 flex-grow" data-id="element-235">
              {maestroFeatures.map((feature, i) => <li key={i} className="flex items-start gap-3" data-id="element-236">
                  <Zap className="w-5 h-5 text-slate-300 shrink-0 mt-0.5" data-id="element-237" />
                  <span className={i === 10 ? 'text-slate-200 font-bold' : 'text-slate-300'} data-id="element-238">
                    {feature}
                  </span>
                </li>)}
            </ul>

            <a href="https://emprendepackcentral.store/cart/47825327259842:1" target="_blank" rel="noopener noreferrer" className="block" data-id="element-239">
              <Button variant="premium" size="lg" fullWidth data-id="element-240">
                ⚡ QUIERO EL MEGAPACK + MEGA BIBLIOTECA
              </Button>
            </a>
          </motion.div>
        </div>

        <p className="text-center text-slate-400 text-sm mb-20" data-id="element-241">
          Podés pagar con tarjeta de crédito o débito, transferencia bancaria o
          Mercado Pago en pesos argentinos.
        </p>

        {/* Upsell Details */}
        <div className="max-w-4xl mx-auto" data-id="element-242">
          <div className="text-center mb-10" data-id="element-243">
            <h3 className="text-2xl md:text-3xl font-extrabold text-white flex items-center justify-center gap-2" data-id="element-244">
              <Target className="w-8 h-8 text-slate-300" data-id="element-245" />
              🎯 ¿QUÉ AGREGA LA MEGA BIBLIOTECA PREMIUM?
            </h3>
          </div>

          <div className="overflow-x-auto pb-4 mb-12" data-id="element-246">
            <div className="min-w-[700px]" data-id="element-247">
              <div className="grid grid-cols-3 gap-4 mb-4 px-4" data-id="element-248">
                <div className="font-bold text-slate-400 uppercase text-sm tracking-wider" data-id="element-249">
                  Situación
                </div>
                <div className="font-bold text-red-400 uppercase text-sm tracking-wider" data-id="element-250">
                  ❌ Sin Mega Biblioteca
                </div>
                <div className="font-bold text-slate-300 uppercase text-sm tracking-wider" data-id="element-251">
                  ✅ Con Mega Biblioteca
                </div>
              </div>

              <div className="space-y-2" data-id="element-252">
                {comparisonRows.map((row, i) => <div key={i} className="grid grid-cols-3 gap-4 bg-[#06140d]/60 rounded-xl p-4 items-center border border-[#1a3d2c]" data-id="element-253">
                    <div className="text-slate-300 font-medium text-sm" data-id="element-254">
                      {row.sit}
                    </div>
                    <div className="text-red-300/80 text-sm" data-id="element-255">{row.sin}</div>
                    <div className="text-slate-200 font-medium text-sm" data-id="element-256">
                      {row.con}
                    </div>
                  </div>)}
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-br from-[#0c241a] to-[#1a3d2c] rounded-2xl p-6 md:p-8 border border-slate-400/30 shadow-xl" data-id="element-257">
            <h4 className="font-bold text-slate-200 mb-6 uppercase tracking-wider" data-id="element-258">
              LA MEGA BIBLIOTECA PREMIUM INCLUYE:
            </h4>
            <div className="space-y-6" data-id="element-259">
              <div data-id="element-260">
                <p className="font-bold text-white flex items-center gap-2 mb-1" data-id="element-261">
                  <span className="text-slate-300" data-id="element-262">🌱</span> Ganadería
                  Sustentable y Bioenergía
                </p>
                <p className="text-slate-300 text-sm" data-id="element-263">
                  Integración de energías renovables con producción agropecuaria
                  argentina
                </p>
              </div>
              <div data-id="element-264">
                <p className="font-bold text-white flex items-center gap-2 mb-1" data-id="element-265">
                  <span className="text-slate-300" data-id="element-266">🏛️</span> Gestión de
                  Proyectos Institucionales
                </p>
                <p className="text-slate-300 text-sm" data-id="element-267">
                  Cómo llevar un proyecto renovable desde el aula hasta la
                  dirección escolar
                </p>
              </div>
              <div data-id="element-268">
                <p className="font-bold text-white flex items-center gap-2 mb-1" data-id="element-269">
                  <span className="text-slate-300" data-id="element-270">🤝</span> Vinculación con el
                  Sector Productivo
                </p>
                <p className="text-slate-300 text-sm" data-id="element-271">
                  Estrategias para conectar tu escuela con empresas y
                  cooperativas de energía
                </p>
              </div>
              <div data-id="element-272">
                <p className="font-bold text-white flex items-center gap-2 mb-1" data-id="element-273">
                  <span className="text-slate-300" data-id="element-274">🏆</span> Concursos
                  Nacionales e Internacionales
                </p>
                <p className="text-slate-300 text-sm" data-id="element-275">
                  Guía completa para participar con tus alumnos en competencias
                  reales
                </p>
              </div>
              <div data-id="element-276">
                <p className="font-bold text-white flex items-center gap-2 mb-1" data-id="element-277">
                  <span className="text-slate-300" data-id="element-278">🎓</span> Estrategias
                  Pedagógicas Avanzadas
                </p>
                <p className="text-slate-300 text-sm" data-id="element-279">
                  Metodologías actualizadas para enseñar renovables en el siglo
                  XXI
                </p>
              </div>
              <div data-id="element-280">
                <p className="font-bold text-white flex items-center gap-2 mb-1" data-id="element-281">
                  <span className="text-slate-300" data-id="element-282">📚</span> Desarrollo
                  Profesional Docente
                </p>
                <p className="text-slate-300 text-sm" data-id="element-283">
                  Recursos para tu crecimiento como especialista en energías
                  renovables
                </p>
              </div>
              <div data-id="element-284">
                <p className="font-bold text-white flex items-center gap-2 mb-1" data-id="element-285">
                  <span className="text-slate-300" data-id="element-286">💻</span> Recursos
                  Bibliográficos y Digitales
                </p>
                <p className="text-slate-300 text-sm" data-id="element-287">
                  Biblioteca curada con fuentes oficiales, papers y plataformas
                  educativas
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}